import React, { Fragment } from "react";

import Footer from "../components/footer";

const Page = (props) => {
  return (
    <Fragment>
      <div className="container">
        <div className="row">
          <div className="col-md-6 d-block mx-auto p-box">{props.children}</div>
        </div>
      </div>

      <Footer />
    </Fragment>
  );
};

export default Page;
